<div class="m-portlet mf-stat-cube ml-2">
    <div class="m-portlet__body text-center">
        <div class="mf-sum">{{ statData?.sum }}</div>
        <div class="mf-state font-weight-bold">{{ statData?.state?.title }}</div>
    </div>
</div>
